import { reportError } from "./reportError";

/**
 * Registers the service worker (install as an app, offline, market notifications) like the plugin's
 * own registerSW.js did, but handling a refusal: some browsers and extensions wrap
 * navigator.serviceWorker.register and reject it with "Rejected", which the plugin's script left as an
 * uncaught error in the admins' digest. The page works the same without it. Any other failure (a
 * broken sw.js after a deploy) is still reported.
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err: unknown) => {
      if (err instanceof Error && err.message === "Rejected") return;
      reportError(err, "service worker");
    });
  });
}
